import { ROUTES } from "@constants/routes";
import { getAccess } from "@helpers/permissionController";
import { useUser } from "@hooks/useUser";
import { IconPackage } from "@pentabd/icons";
import { Button, Header } from "@pentabd/ui";
import { VendorCreateType } from "@type/procurements/vendor";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { STATUS } from "@constants/status.procurement";
import { useNavigate } from "react-router-dom";
import { ErrorModal, SuccessModal } from "@components";
import { verifyVendor } from "@api/procurements/vendor";

const { PENDING } = STATUS;

export default function AddNewVendorsHeader({
  data,
  id,
}: {
  data: VendorCreateType | null;
  id: string | undefined;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // permissions
  const { user } = useUser();
  const { realm_roles: roles } = user || {};
  const [canApproveVendor, setCanApproveVendor] = useState(false);

  // modals
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);

  const breadcrumbs = [
    {
      icon: <IconPackage fill="dark" size="20" />,
    },
    {
      link: ROUTES.PROCUREMENT.VENDORS,
      label: t("PROCUREMENT_ADD_VENDORS.BREADCRUMBS.FIRST_STEP"),
    },
    {
      label: t("PROCUREMENT_ADD_VENDORS.BREADCRUMBS.SECOND_STEP"),
    },
  ];

  const headerText = {
    header: t("PROCUREMENT_ADD_VENDORS.LABEL"),
  };

  const handleApproval = async () => {
    try {
      const res = await verifyVendor(id as string, { isApproved: true });

      setIsSuccessModalOpen(true);
    } catch (error) {
      setIsErrorModalOpen(true);
    }
  };

  const successAction = () => {
    setIsSuccessModalOpen(false);
    navigate(`${ROUTES.PROCUREMENT.VENDORS}`);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  const actions = [
    <Button fill="fill" type="primary" onClick={handleApproval}>
      {t("PROCUREMENT_ADD_VENDORS.FORM.APPROVE_BUTTON.BUTTON_TEXT")}
    </Button>,
  ];

  useEffect(() => {
    setCanApproveVendor(
      getAccess(roles, "APPROVE_VENDOR") &&
        data?.approvalStatus?.toUpperCase() === PENDING,
    );
  }, [data]);

  return (
    <div>
      {/* modals  */}
      {isSuccessModalOpen && (
        <SuccessModal isModalOpen={isSuccessModalOpen} action={successAction} />
      )}
      {isErrorModalOpen && (
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
      )}

      {/* modals end */}
      <Header
        headerText={headerText}
        breadcrumbs={breadcrumbs}
        actions={canApproveVendor ? actions : [<></>]}
      />
    </div>
  );
}
